import React from "react";
import aboutvideo from "../../Assets/images/about-us2.mp4";

const About = () => {
  return (
    <>
      <section className="py-10 relative xl:mr-0 lg:mr-5 mr-0 overflow-hidden">
        <div className="w-full  container px-2 md:px-5 lg:px-5 mx-auto">
          <div className="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-2 grid-cols-1">
            <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex ">
              <div className="w-full flex-col justify-center items-start gap-8 flex">
                <div className="flex-col justify-start lg:items-start items-center gap-4 flex">
                  <span className="py-2 px-2 span-bx rounded-full text-md font-medium text-[#ffe400ba] text-center w-24 ">
                    About Us
                  </span>
                  <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                    <h2 className=" text-4xl sm:text-5xl text-center md:text-left font-bold  bg-gradient-to-r from-yellow-500 via-blue-500 to-blue-600  text-transparent bg-clip-text mb-2 ">
                      About the Exbit Ecosystem
                    </h2>
                    <p className="text-white text-base font-normal leading-relaxed lg:text-start text-center">
                      Exbit is a cutting-edge blockchain platform designed to
                      empower users in the digital finance and gaming space.
                    </p>
                    <ul>
                      <li className="flex items-center py-2 space-x-4 xl:py-3">
                        <svg
                          className="w-12 h-12 text-blue-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                          />
                        </svg>
                        <span className="font-medium text-white text-justify">
                          Operating on the Binance Smart Chain, Exbit provides a
                          reliable and efficient platform for seamless
                          cryptocurrency trading and staking.
                        </span>
                      </li>
                      <li className="flex items-center py-2 space-x-4 xl:py-3">
                        <svg
                          className="w-10 h-10 text-yellow-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                          />
                        </svg>
                        <span className="font-medium text-white ">
                          Engage with Games and explore innovative liquidity
                          farming opportunities to maximize your investments.
                        </span>
                      </li>
                      <li className="flex items-center py-2 space-x-4 xl:py-3">
                        <svg
                          className="w-10 h-12 text-blue-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                          />
                        </svg>
                        <span className="font-medium text-white text-justify">
                          Experience cutting-edge blockchain gaming within
                          Exbit's all-in-one solution for managing and
                          interacting with digital assets.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:justify-start justify-center items-start flex">
  <div className="about-img relative ">
    <video
      className="sm:mt-5 sm:ml-5 w-full h-full rounded-3xl object-cover relative z-20 mix-blend-exclusion "
     
      autoPlay
      loop
      muted
      playsInline
    >
       <source src={aboutvideo} type="video/mp4" />
                  {/* <source src={aboutvideowebm} type="video/webm" /> */}
      Your browser does not support the video tag.
    </video>
  </div>
</div>
          </div>

          <div className="section_aboutsec-bg-gradient animate-pulse" />
        </div>
      </section>
    </>
  );
};

export default About;
